import "./index.css";
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// Pages
import Erreur from "./Pages/Erreur";
import Accueil from "./Pages/Accueil";
import Alfa from "./Pages/Alfa";
import Bravo from "./Pages/Bravo";
import Charlie from "./Pages/Charlie";
import Delta from "./Pages/Delta";
import Echo from "./Pages/Echo";
import NousJoindre from "./Pages/NousJoindre";
import Hebergement from "./Pages/Hebergement";
import Evenement from "./Pages/Evenement";
import Activite from "./Pages/Activite";
import Compte from "./Pages/Compte";
import Historique from "./Pages/Historique";
import Logoipsum from "./Pages/Logoipsum";
import Equipe from "./Pages/Equipe";
import Emplois from "./Pages/Emplois";
import Reservation from "./Pages/Reservation";
// Barre de navigation
import Navbar from "./Components/Navbar";
// Footer
import Footer from "./Components/Footer";
function App() {
  return (
    <div className="container">
      <Router>
        <Navbar />
        <Switch>
          <Route exact path="/">
            <Accueil />
          </Route>
          <Route path="/Pages/Alfa">
            <Alfa />
          </Route>
          <Route path="/Pages/Bravo">
            <Bravo />
          </Route>
          <Route path="/Pages/Charlie">
            <Charlie />
          </Route>
          <Route path="/Pages/Delta">
            <Delta />
          </Route>
          <Route path="/Pages/Echo">
            <Echo />
          </Route>
          <Route path="/Pages/NousJoindre">
            <NousJoindre />
          </Route>
          <Route path="/Page/Evenement">
            <Evenement />
          </Route>
          <Route path="/Pages/Hebergement">
            <Hebergement />
          </Route>
          <Route path="/Pages/Activite">
            <Activite />
          </Route>
          <Route path="/Pages/Compte">
            <Compte />
          </Route>
          <Route path="/Pages/Historique">
            <Historique />
          </Route>
          <Route path="/Pages/Logoipsum">
            <Logoipsum />
          </Route>
          <Route path="/Pages/Equipe">
            <Equipe />
          </Route>
          <Route path="/Pages/Emplois">
            <Emplois />
          </Route>
          <Route path="/Pages/Reservation">
            <Reservation />
          </Route>
          <Route path="*">
            <Erreur />
          </Route>
        </Switch>
      </Router>
      <Footer />
    </div>
  );
}

export default App;
